var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchitectureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 141,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28C1A0",
    fillOpacity: 0.1,
    d: "M0 0h93v93H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#28C1A0",
    fillOpacity: 0.1,
    d: "M46 48h93v93H46z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMzkiIGhlaWdodD0iMTQxIiB2aWV3Qm94PSIwIDAgMTM5IDE0MSIgZmlsbD0ibm9uZSI+CiAgICA8cmVjdCB3aWR0aD0iOTMiIGhlaWdodD0iOTMiIGZpbGw9IiMyOEMxQTAiIGZpbGwtb3BhY2l0eT0iMC4xIi8+CiAgICA8cmVjdCB4PSI0NiIgeT0iNDgiIHdpZHRoPSI5MyIgaGVpZ2h0PSI5MyIgZmlsbD0iIzI4QzFBMCIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KPC9zdmc+Cg==";
export { SvgArchitectureIcon as ReactComponent };